import { CATALYT_BASE_URL } from "./api";

export interface ICsrfConfig {
  baseURL: string;
  SID: string;
  appID: string;
  secretKey: string;
}

export const csrfConfig = {
  baseURL: CATALYT_BASE_URL,
} as ICsrfConfig;
